import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { FixedSizeList as List } from "react-window";
import ProgramRow from "./ProgramRow";
import { setPlayingChannel } from "../../actions/playingChannel";
import { useHistory } from "react-router-dom";

const ProgramList = ({
  channels,
  programListRef,
  filteredPrograms,
  formatTime,
  onScroll,
  windowStartTime,
  windowEndTime,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentTimePosition, setCurrentTimePosition] = useState(0);

  const calculateCurrentTimePosition = () => {
    const now = Date.now();
    const windowStart = new Date(windowStartTime).getTime();
    const windowEnd = new Date(windowEndTime).getTime();

    // Ensure the current time is within the window time
    if (now < windowStart || now > windowEnd) {
      return -1; // Return -1 if current time is out of range
    }

    const totalWindowDuration = windowEnd - windowStart;
    const elapsedTime = now - windowStart;
    const positionPercentage = (elapsedTime / totalWindowDuration) * 100;

    return positionPercentage;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTimePosition(calculateCurrentTimePosition());
    }, 1000); // Update every second
    setCurrentTimePosition(calculateCurrentTimePosition());
    return () => clearInterval(interval);
  }, [windowStartTime, windowEndTime]);

  const handleClick = (e, channel) => {
    history.replace(`/live/category/${channel.category_id}/channel/${channel.num}/`);
    e.stopPropagation();
  };

  return (
    <Box sx={{ position: "relative", width: "100%", zIndex: 4 }}>
      {/* Conditionally hide line if outside time window */}
      {currentTimePosition >= 0 && currentTimePosition <= 100 && (
        <>
          {/* Light overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 3,
              left: 0,
              width: `${currentTimePosition}%`,
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              zIndex: 5,
              pointerEvents: "none",
            }}
          />

          {/* Time line */}
          <Box
            sx={{
              position: "absolute",
              top: 3,
              left: `${currentTimePosition}%`,
              width: "2px",
              height: "100%",
              backgroundColor: "#039dfc",
              zIndex: 10,
            }}
          >
            {/* Circle
            <Box
              sx={{
                position: "absolute",
                top: "-15px",
                left: "-7px",
                width: "14px",
                height: "14px",
                backgroundColor: "#039dfc",
                borderRadius: "50%",
                zIndex: 15,
              }}
            /> */}
          </Box>
        </>
      )}

      {/* Program List */}
      <List
        height={window.innerHeight - 100}
        itemCount={channels.length}
        itemSize={50}
        width="100%"
        ref={programListRef}
        onScroll={({ scrollOffset }) => onScroll(scrollOffset)}
      >
        {({ index, style }) => (
          <ProgramRow
            index={index}
            style={style}
            channels={channels}
            filteredPrograms={filteredPrograms}
            formatTime={formatTime}
            windowStartTime={windowStartTime}
            windowEndTime={windowEndTime}
            onClick={handleClick}
          />
        )}
      </List>
    </Box>
  );
};

export default ProgramList;
